<template>
  <v-row class="text-left ml-0 pl-0">
    <v-col cols="12" class="v-label my-0 py-0 ml-0 pl-0">
      {{ label }}
    </v-col>
    <v-col cols="12" class="my-0 py-0 ml-0 pl-0">
      <v-row class="my-0 py-0 ml-0 pl-0">
        <v-col
            cols="1"
            class="align-self-start">
          <file-input
              ref="fileInput"
              :color="color"
              :icon="icon"
              :accept="accept"
              :tip="$t('Добавить файл')"
              @change="changeFiles" />
        </v-col>
        <v-col
            cols="1">
          <btn-icon-tip
              v-if="files.length"
              icon="clear"
              icon-color="red"
              :tip="$t('Очистить')"
              @click="clear" />
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="files.length" class="my-0 py-0 ml-0 pl-0">
      <v-list dense>
        <v-list-item
            v-for="(item, i) in files"
            :key="i"
            class="align-self-start">
          <v-list-item-content class="align-self-start">
            <v-list-item-title>
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ Math.ceil(item.size/1024) }} {{ $t('Кб') }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <btn-icon-tip
                icon="cancel"
                icon-color="textcolor"
                :tip="$t('Удалить файл')"
                small
                @click="remove(i)" />
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
  import FileInput from './FileInput.vue'
  import BtnIconTip from './BtnIconTip.vue'
  export default {
    components: {
      FileInput,
      BtnIconTip
    },
    props: {
      value: {
        type: Array
      },
      accept: {
        type: String,
        default: '.xls,.xlt,.xla,.xlsx,.xltx,.xlsm,.xltm,.xlam,.xlsb,.doc,.dot,.docx,.dotx,.docm,.dotm,.pdf,.tif,.tiff,.jpeg,.jpg,.bmp,.png,.csv,.sig,.xml,.rar,.zip,.7z,.txt'
      },
      color: {
        type: String,
        default: 'addbtn'
      },
      icon: {
        type: String,
        default: 'attach_file'
      },
      label: {
        type: String,
        default: ''
      },
      maxFileSize: {
        type: Number,
        default: 31457280
      }
    },
    data () {
      return {
        files: []
      }
    },
    computed: {
      maxFileSizeError () {
        return this.$t('Максимальный размер загружаемых файлов 50 Мб')
      },
      disabled () {
        return !!this.files.length
      }
    },
    methods: {
      clear: function () {
        this.$refs.fileInput.clear()
        this.files = []
        this.$emit('input', this.files)
      },
      remove: function (index) {
        this.files.splice(index, 1)
        this.$emit('input', this.files)
      },
      changeFiles: function (file) {
        if (!file) {
          return
        }
        this.files.push(file)
        const totalSize = this.files.reduce((prev, current) => {
          return prev.size + current.size
        })
        if (totalSize > this.maxFileSize) {
          this.showErrorAction({
            message: this.maxFileSizeError
          })
        }
        this.$emit('input', this.files)
      }
    }
  }
</script>
